<div (click)="openStep()" [ngClass]="className" class="process-step">
    <div class="stepIcon" fxLayout="row" fxLayoutAlign="center center">
        <forge-icon *ngIf="showComplete" name="check_circle" style="color:#3F51B5;"></forge-icon>
        <forge-icon *ngIf="showReady" name="lens" style="color:#3F51B5;"></forge-icon>
        <forge-icon *ngIf="showLocked" name="radio_button_unchecked" style="color: #757575;"></forge-icon>
        <div class="forge-typography--label1" style="margin: 0 .25rem;">{{entity.Name}}</div>
    </div>
</div>